<div class="{{setClass}} favorite" [ngClass]="{active: item.favorite}" (click)="toggleFavorite()">
    <svg class="favorite__ico">
        <use xlink:href="/assets/img/sprite.svg#favorite"></use>
    </svg>
</div>